module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lP851"))).then(() => parcelRequire('1iHdE'));